type Meeting = {
  meetingParticipants: { __typename: string; userId: string; relationshipToParent: string }[];
};
type WitnessConfirmMessage = {
  user_id: string;
  relationship_to_parent: string;
};

export const confirmWitnessEvent = [
  "witness_confirmed",
  (meeting: Meeting, socketMessage: unknown) => {
    const { user_id: userId, relationship_to_parent: relationshipToParent } =
      socketMessage as WitnessConfirmMessage;
    return {
      ...meeting,
      meetingParticipants: meeting.meetingParticipants.map((part) => {
        return part.__typename === "WitnessParticipant" && part.userId === userId
          ? { ...part, relationshipToParent }
          : part;
      }),
    };
  },
] as const;
